import React from "react"
import { graphql } from "gatsby"
import { Layout, Section, EntryRows, isPresentation } from "../components/Site"

export default ({ data }) => {
  const nodes = data.allMarkdownRemark.nodes

  return (
    <Layout title="Talks and writing">
      <h1 className="page-title">Talks and writing</h1>
      <p className="page-lead">Conference talks, workshops, panels and articles, mostly about R, Shiny and front-end.</p>

      <Section id="talks" n="01" title="Talks, workshops and videos">
        <EntryRows nodes={nodes.filter(isPresentation)} />
      </Section>

      <Section id="writing" n="02" title="Writing">
        <EntryRows nodes={nodes.filter(node => !isPresentation(node))} />
      </Section>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/articles/" } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      nodes {
        id
        frontmatter {
          title
          tags
          link
          date(formatString: "MMM YYYY")
        }
      }
    }
  }
`
